import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseQueryOptions, useQuery } from 'react-query'
import { StrategicRecommendation } from 'types'

interface Props {
  brandKitId: number
}

type Data = StrategicRecommendation[]

export const fetchStrategicRecommendations = async ({ brandKitId, workspaceId }: Props & { workspaceId: number }) => {
  const res = await sendToApi<{ strategic_recommendations: StrategicRecommendation[] }>(
    `/w/${workspaceId}/brand_kits/${brandKitId}/strategic_recommendations`,
  )
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data.strategic_recommendations
}

export const useBrandKitStrategicRecommendations = ({ brandKitId }: Props, options?: UseQueryOptions<Data>) => {
  const workspaceId = useCurrentWorkspaceId()
  const queryKey = ['workspaces', workspaceId, 'brandKits', brandKitId, 'strategicRecommendations']

  return useQuery<Data>(queryKey, () => fetchStrategicRecommendations({ brandKitId, workspaceId }), {
    refetchOnWindowFocus: false,
    ...options,
  })
}
